import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: import.meta.env.VITE_KEYCLOAK_URL || 'https://qavok.io/auth',
  realm: import.meta.env.VITE_KEYCLOAK_REALM || 'qavok',
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'qavok-frontend',
});

export default keycloak;
